import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-5">
      <div className="w-full max-w-md rounded-3xl border border-white/10 bg-[#11141E] p-8 text-center" data-testid="payment-cancel">
        <XCircle className="h-12 w-12 text-slate-400 mx-auto" />
        <h1 className="font-display font-bold text-xl mt-4">Checkout canceled</h1>
        <p className="text-sm text-slate-400 mt-2">No charge was made. You can pick a plan whenever you're ready.</p>
        <Link to="/pricing"><Button className="mt-6 rounded-full bg-[#FF453A] hover:bg-[#FF5D54] text-white font-semibold px-6">Back to plans</Button></Link>
      </div>
    </div>
  );
}
